export default __webpack_public_path__ + "static/media/DefaultLogo.6339a31d.svg";